import { Paper, Text, Stack, Box, Group } from '@mantine/core'
import { IconCircleCheck } from '@tabler/icons-react'

export function DeliverablesList({ title, weeks, deliverables }) {
  if (!deliverables?.length) return null

  return (
    <Paper p="md" className="glass">
      <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" fw={600} tt="uppercase" lts={1} mb={2}>
        {title}
      </Text>
      <Text size="xs" c="dimmed" mb="sm">{weeks}</Text>
      <Stack gap={4}>
        {deliverables.map((d, i) => (
          <Group key={i} gap="xs" wrap="nowrap" align="flex-start">
            <IconCircleCheck size={14} color="var(--mantine-color-green-5)" style={{ flexShrink: 0, marginTop: 2 }} />
            <Box>
              <Text size="sm" c="gray.3" fw={600} span>{d.name}</Text>
              <Text size="xs" c="dimmed" span> — {d.description}</Text>
            </Box>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}
